<template>
  <div
    v-if="showLoadingState < 1"
    key="loadingState"
    class="m-initial-loading"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    class="m-card-primary m-card-transition m-card-record-info m-card-record-link margin-auto"
  >
    <div v-if="!venta.venta.precio || !venta.venta.id_plan">
      <div v-if="venta.venta.venta_estado === 5 || venta.venta.venta_estado === 8">
        <p>
          {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElseIf.line1') }}
          <span class="font-weight-bold">
            {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElseIf.cancelled') }}
          </span>
          <br>{{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElseIf.line2') }}
        </p>
      </div>
      <div v-else>
        <p @click="modalCancelVenta">
          {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElse.line1') }}
          <br> {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElse.line2') }}
          <span class="font-weight-bold">
            {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElse.line3') }}
          </span>
        </p>
        <p
          class="recod-link-call-to-action recod-link-call-to-action-danger"
          @click="modalCancelVenta"
        >
          {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraph.cancel') }}
        </p>
      </div>
    </div>

    <div v-else>
      <div v-if="venta.venta.venta_estado === 5 || venta.venta.venta_estado === 8">
        <div v-if="venta.venta.fecha_cancelar_venta">
          <p>
            {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElseIf.line1') }}
            <span class="font-weight-bold">
              {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElseIf.cancelled') }}
            </span>
            <br>{{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElseIf.line3') }}
            <span style="border-bottom: 1px dashed var(--color-brand-billing-primary);">
              {{ $moment.parseZone(venta.venta.fecha_cancelar_venta).format('D MMMM, YYYY') }}
            </span>
            <br>{{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElseIf.line4') }}
          </p>
        </div>
        <div v-else>
          <p>
            {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElseIf.line1') }}
            <span class="font-weight-bold">
              {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElseIf.cancelled') }}
            </span>
            <br>{{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElseIf.line2') }}
          </p>
        </div>
      </div>
      <div v-else>
        <p>
          {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElse.line1') }}
          <br> {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElse.line2') }}
          <span class="font-weight-bold">
            {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElse.line3') }}
          </span>
        </p>
        <p
          v-if="venta.venta.medio_pago"
          class="recod-link-call-to-action recod-link-call-to-action-danger"
          @click="modalCancelSubscription"
        >
          {{ $t('mEditionBillingMyPaymentsCancelSubscription.paragraphElse.cancel') }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'MoleculeEditionBillingMyPaymentsCancelSubscription',

  data () {
    return {
      showLoadingState: 0,
      suscripcion: null,
      venta: null
    }
  },

  computed: {
    updatedData () {
      return this.$modal.updatedData
    }
  },

  watch: {
    updatedData () {
      this.showLoadingState = 0
      this.readVenta()
    }
  },

  created () {
    this.readVenta()
  },

  methods: {
    modalCancelSubscription () {
      this.$modal.showModal('MoleculeEditionBillingMyPaymentsModalCancelSubscription', { venta: this.venta.venta })
    },

    modalCancelVenta () {
      this.$modal.showModal('MoleculeEditionBillingMyPaymentsModalCancelVenta', { venta: this.venta.venta })
    },

    readVenta () {
      this.$services.read('ventas', 'readVenta', {}, [this.$store.getters.getAcademyData.licencia.venta])
        .then(response => {
          this.venta = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    }
  }
}
</script>
